var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "mediaForm",
          attrs: {
            model: _vm.mediaForm,
            rules: _vm.rules,
            "label-width": "160px",
            "validate-on-rule-change": false,
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "内容名称：", prop: "title" } },
            [
              _c("el-input", {
                attrs: {
                  maxlength: "99",
                  size: "small",
                  clearable: "",
                  placeholder: "内容标题",
                },
                model: {
                  value: _vm.mediaForm.title,
                  callback: function ($$v) {
                    _vm.$set(_vm.mediaForm, "title", $$v)
                  },
                  expression: "mediaForm.title",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              ref: "coverImg",
              attrs: { label: "内容图片：", prop: "coverImg" },
            },
            [
              _c(
                "el-upload",
                {
                  staticClass: "avatar-uploader",
                  attrs: {
                    "before-upload": _vm.fileCheck,
                    "http-request": (params) => _vm.upload(params, "coverImg"),
                    "show-file-list": false,
                  },
                },
                [
                  _vm.mediaForm.coverImg
                    ? _c("el-image", {
                        staticClass: "avatar",
                        attrs: { src: _vm.mediaForm.coverImg, fit: "contain" },
                      })
                    : _c("i", {
                        staticClass: "el-icon-plus avatar-uploader-icon",
                      }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              ref: "hdCoverImg",
              attrs: { label: "高清封面图片：", prop: "hdCoverImg" },
            },
            [
              _c(
                "el-upload",
                {
                  staticClass: "avatar-uploader",
                  attrs: {
                    "before-upload": _vm.fileCheck,
                    "http-request": (params) =>
                      _vm.upload(params, "hdCoverImg"),
                    "show-file-list": false,
                  },
                },
                [
                  _vm.mediaForm.hdCoverImg
                    ? _c("el-image", {
                        staticClass: "avatar",
                        attrs: {
                          src: _vm.mediaForm.hdCoverImg,
                          fit: "contain",
                        },
                      })
                    : _c("i", {
                        staticClass: "el-icon-plus avatar-uploader-icon",
                      }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "图片宽度尺寸：", prop: "imgSelectWidth" } },
            [
              _c(
                "div",
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.mediaForm.imgSelectWidth,
                        callback: function ($$v) {
                          _vm.$set(_vm.mediaForm, "imgSelectWidth", $$v)
                        },
                        expression: "mediaForm.imgSelectWidth",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "300" } }, [
                        _vm._v("小图：300px (推荐)"),
                      ]),
                      _c("el-radio", { attrs: { label: "700" } }, [
                        _vm._v("大图：700px (推荐)"),
                      ]),
                      _c("el-radio", { attrs: { label: -1 } }, [
                        _vm._v("自定义图片宽度"),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-popover",
                    {
                      attrs: {
                        placement: "top-start",
                        width: "200",
                        trigger: "hover",
                        content:
                          "如果输入了自定义图片宽度，以自定义图片宽度为准",
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "el-icon-question",
                        staticStyle: {
                          "margin-left": "40px",
                          color: "#507dc5",
                        },
                        attrs: { slot: "reference" },
                        slot: "reference",
                      }),
                    ]
                  ),
                ],
                1
              ),
              _vm.mediaForm.imgSelectWidth === -1
                ? _c("el-input", {
                    staticStyle: { width: "400px" },
                    attrs: {
                      size: "small",
                      clearable: "",
                      placeholder: "请输入图片宽度(单位px)",
                    },
                    model: {
                      value: _vm.mediaForm.customImgWidth,
                      callback: function ($$v) {
                        _vm.$set(_vm.mediaForm, "customImgWidth", $$v)
                      },
                      expression: "mediaForm.customImgWidth",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "显示顺序：", prop: "displayOrder" } },
            [
              _c("el-input", {
                attrs: {
                  size: "small",
                  clearable: "",
                  placeholder: "按照顺序进行显示，相同数字按时间排序",
                },
                model: {
                  value: _vm.mediaForm.displayOrder,
                  callback: function ($$v) {
                    _vm.$set(_vm.mediaForm, "displayOrder", $$v)
                  },
                  expression: "mediaForm.displayOrder",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "热度值：", prop: "hotScore" } },
            [
              _c("el-input", {
                attrs: {
                  size: "small",
                  clearable: "",
                  placeholder: "输入整数",
                },
                model: {
                  value: _vm.mediaForm.hotScore,
                  callback: function ($$v) {
                    _vm.$set(_vm.mediaForm, "hotScore", $$v)
                  },
                  expression: "mediaForm.hotScore",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "推荐标签：", prop: "recommendedTags" } },
            [
              _c("el-input", {
                attrs: {
                  maxlength: "99",
                  size: "small",
                  clearable: "",
                  placeholder: "推荐标签",
                },
                model: {
                  value: _vm.mediaForm.recommendedTags,
                  callback: function ($$v) {
                    _vm.$set(_vm.mediaForm, "recommendedTags", $$v)
                  },
                  expression: "mediaForm.recommendedTags",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "响应方式：", prop: "skipType" } },
            [_c("div", [_vm._v(_vm._s(_vm.getSkipTypeText))])]
          ),
          _c(
            "el-form-item",
            { attrs: { label: "宣传标签：", prop: "tags" } },
            [
              _c("el-input", {
                attrs: {
                  maxlength: "99",
                  size: "small",
                  clearable: "",
                  placeholder: "宣传标签",
                },
                model: {
                  value: _vm.mediaForm.tags,
                  callback: function ($$v) {
                    _vm.$set(_vm.mediaForm, "tags", $$v)
                  },
                  expression: "mediaForm.tags",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "内容标签：", prop: "category" } },
            [
              _c("el-input", {
                staticStyle: { width: "200px", "margin-right": "10px" },
                attrs: { size: "small", placeholder: "输入文案" },
                model: {
                  value: _vm.mediaForm.categoryInput,
                  callback: function ($$v) {
                    _vm.$set(_vm.mediaForm, "categoryInput", $$v)
                  },
                  expression: "mediaForm.categoryInput",
                },
              }),
              _c(
                "el-button",
                { attrs: { size: "small" }, on: { click: _vm.insertCategory } },
                [_vm._v("添加")]
              ),
              _c(
                "div",
                { staticStyle: { "margin-top": "10px" } },
                _vm._l(_vm.contentList, function (item, index) {
                  return _c(
                    "el-tag",
                    {
                      key: item,
                      staticStyle: { "margin-right": "10px" },
                      attrs: { closable: "" },
                      on: {
                        close: () => {
                          _vm.mediaForm.category = _vm.contentList
                            .filter((tag, i) => i !== index)
                            .join(",")
                        },
                      },
                    },
                    [_vm._v(_vm._s(item))]
                  )
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "描述：", prop: "description" } },
            [
              _c("el-input", {
                attrs: {
                  maxlength: "99",
                  size: "small",
                  clearable: "",
                  placeholder: "输入文案",
                },
                model: {
                  value: _vm.mediaForm.description,
                  callback: function ($$v) {
                    _vm.$set(_vm.mediaForm, "description", $$v)
                  },
                  expression: "mediaForm.description",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "备注：", prop: "remark" } },
            [
              _c("el-input", {
                attrs: {
                  "show-word-limit": "",
                  maxlength: "9999",
                  type: "textarea",
                  size: "small",
                  placeholder: "请输入备注",
                  clearable: "",
                },
                model: {
                  value: _vm.mediaForm.remark,
                  callback: function ($$v) {
                    _vm.$set(_vm.mediaForm, "remark", $$v)
                  },
                  expression: "mediaForm.remark",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "状态：", prop: "status" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.mediaForm.status,
                    callback: function ($$v) {
                      _vm.$set(_vm.mediaForm, "status", $$v)
                    },
                    expression: "mediaForm.status",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: 1 } }, [_vm._v("生效")]),
                  _c("el-radio", { attrs: { label: 0 } }, [_vm._v("失效")]),
                ],
                1
              ),
            ],
            1
          ),
          _vm.mediaForm.status === 1
            ? _c(
                "el-form-item",
                { attrs: { label: "选择", prop: "effectMode" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.mediaForm.effectMode,
                        callback: function ($$v) {
                          _vm.$set(_vm.mediaForm, "effectMode", $$v)
                        },
                        expression: "mediaForm.effectMode",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v("立即生效"),
                      ]),
                      _c("el-radio", { attrs: { label: 2 } }, [
                        _vm._v("指定时间生效"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.mediaForm.status === 1 && _vm.mediaForm.effectMode === 2
            ? _c(
                "el-form-item",
                { attrs: { label: "生效时间", prop: "effectTime" } },
                [
                  _c("el-date-picker", {
                    attrs: {
                      size: "small",
                      "picker-options": {
                        disabledDate(time) {
                          return time.getTime() < Date.now() - 8.64e7
                        },
                      },
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      type: "datetimerange",
                      "range-separator": "至",
                      "start-placeholder": "生效开始时间",
                      "end-placeholder": "生效结束时间",
                      clearable: "",
                    },
                    model: {
                      value: _vm.mediaForm.effectTime,
                      callback: function ($$v) {
                        _vm.$set(_vm.mediaForm, "effectTime", $$v)
                      },
                      expression: "mediaForm.effectTime",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "btn-container",
              staticStyle: { "text-align": "right", "margin-top": "20px" },
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.save },
                },
                [_vm._v("保存")]
              ),
              _c(
                "el-button",
                { attrs: { size: "small" }, on: { click: _vm.cancel } },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }